import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'

const formHelper = (target) => {
  if (target) {
    target.style.position = 'absolute'
    target.style.height = 0
    target.style.overflow = 'hidden'
    target.style.pointerEvents = 'none'
  } else {
    console.warn('Form Helper: No target given')
  }
}

/**
 * Fetch address results from getAddress.io & display popup
 * - Pop up uses Sweetalert2
 * - Pop up returns an object including the target element, 
 *   and selected address
 * 
 * @param {String} searchVal 
 * @param {Element} target 
 * @returns {Promise} 
 */
const _getLookupPostcode = (
  searchVal = false, 
  target = false
) => {
  return new Promise((resolve, reject) => {
    if (searchVal && target) {
    let url = 'https://api.getAddress.io/find/'
    fetch(`${url}${searchVal.replace(' ', '')}?api-key=vFgJ9Z1HEUiyZtNPy-tFxQ10270`)
      .then(response => response.json())
      .then(result => {
        if (result.addresses.length > 0) {
          let addresses = cleanAddresses(result.addresses);
          Swal.fire({
            title: "Please select an address",
            input: "select",
            inputOptions: addresses,
            inputPlaceholder: "Select address",
					  showCancelButton: true,
          }).then((res) => {
              if(res.isDismissed) return

              let address = result.addresses[parseInt(res.value)].split(',')
              let addressLineOne = ''
              let addressLineTwo = ''
              let addressLineThree = ''
              let addressLineFour = ''

              if (address[0].replace(/\s+/g, "") !== "") {
                addressLineOne = address[0]
              }
              if (address[1].replace(/\s+/g, "") !== "") {
                addressLineTwo = address[1]
              }
              if (address[2].replace(/\s+/g, "") !== "") {
                addressLineThree = address[2]
              }
              if (address[3].replace(/\s+/g, "") !== "") {
                addressLineFour = address[3]
              }

              resolve({
                address: address,
                addressLineOne: addressLineOne.trim(),
                addressLineTwo: addressLineTwo.trim(),
                addressLineThree: addressLineThree.trim(),
                addressLineFour: addressLineFour.trim(),
                target: target
              })
            })
        } else {
          reject('Unable to find addresses')
        }
      })
      .catch(reason => {
        let err = new Error('Unable to find addresses', {  case: reason })
        throw err;
      })
    } else {
      reject('Get Lookup Postcode: No search value given')
    }
  })
}

/**
 * Lookup a postcode
 * - Request address data then update DOM
 * 
 * @param {Element} target 
 */
const lookupPostcode = (target) => {
  if (target) {
    let postcodeVal = document.getElementById(`${target.dataset.target}Postcode`).value
    let addressObj = _getLookupPostcode(postcodeVal.replace(' ', ''), target)

    addressObj.catch((err) => {
      console.warn(err)
      Swal.fire({
        icon: "error",
        title: "Sorry",
        text: "We couldn't find that address"
      })
    })

    addressObj.then((result) => {
      document.getElementById(`${target.dataset.target}Address1`).value = result.addressLineOne ?? ''
      document.getElementById(`${target.dataset.target}Address2`).value = result.addressLineTwo ?? ''
      document.getElementById(`${target.dataset.target}Address3`).value = result.addressLineThree ?? ''
      document.getElementById(`${target.dataset.target}Address4`).value = result.addressLineFour ?? ''
      document.getElementById(`${target.dataset.target}City`).value = result.address[5] ?? ''
      document.getElementById(`${target.dataset.target}County`).value = result.address[6] ?? ''
      document.getElementById(`${target.dataset.target}Country`).value = 'UK'
    })
  } else {
    console.warn('Lookup Postcode: No target element given')
  }
}

const cleanAddresses = (addresses) => {
  const newAddresses = [];

  addresses.forEach(address => {
    let formattedAddress = formatAddress(address);

    newAddresses.push(formattedAddress);
  });

  return newAddresses;
}

const formatAddress = (address) => {
  return address
    .split(',')
    .filter(addressRow => addressRow.replace(/\s+/g, "") !== "")
    .join(',')
}

const initForms = () => {
  const lookupPostcodeEl = document.querySelector('.js-lookup-postcode')
  if (lookupPostcodeEl && !lookupPostcodeEl.closest('form').dataset.ajax) {
    lookupPostcodeEl.addEventListener('click', (ev) => lookupPostcode(lookupPostcodeEl))
  } else {
    // AJAX: Multipage forms
    document.addEventListener('click', (ev) => {
      if (ev.target.classList.contains('js-lookup-postcode')) lookupPostcode(ev.target);
    })
  }

  const formHelperEls = document.querySelectorAll('.js-form-helper')
  if (formHelperEls) {
    Array.from(formHelperEls, target => formHelper(target))
  }
}

export { initForms }